import React from 'react'
import createRenderer from '@components/FormField'
import './Date.css'

const Date = createRenderer((input, label, language, rest) => (
	<input id={input.name} className="fieldDate" type="date" {...input} />
))

export default Date
